import { useQuery, useQueryClient } from '@tanstack/react-query'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { ReadEvent } from '../schemas/event-schemas'
import { EVENT_KEY } from './use-event-by-id'
import { useRedirectToCurrentEventState } from './use-redirect-to-current-event-state'

const CURRENT_EVENT_KEY = 'current-event'

async function getCurrentEvent(storeId) {
  console.debug('Fetching current event for storeId:', storeId)
  const url = new URL(`/v1/stores/${storeId}/events/current`, process.env.REACT_APP_EVENTS_SERVICE)
  const response = await axios.get(url)
  const parseResult = ReadEvent.safeParse(response.data)
  if (!parseResult.success) {
    console.error('Event data validation failed:', parseResult.error)
    throw new Error('Invalid event data format')
  }
  return parseResult.data
}

export function useCurrentEvent() {
  const queryClient = useQueryClient()
  const { storeId } = useParams()
  const navigate = useNavigate()
  const { redirectToCurrentState } = useRedirectToCurrentEventState()
  useQuery({
    queryKey: [CURRENT_EVENT_KEY, storeId],
    queryFn: async () => getCurrentEvent(storeId),
    onSuccess: (event) => {
      console.debug('Current event fetched successfully:', event)
      queryClient.setQueryData([EVENT_KEY, storeId, event.eventId], event)

      redirectToCurrentState(event)
    },
    onError: (error) => {
      console.error('Error fetching current event:', error)
      return navigate(`/store/${storeId}/event/not-found`, { replace: true })
    },
    enabled: !!storeId,
    retry: false,
    retryOnMount: false,
    refetchOnMount: false,
  })
}
